<script>
  import NavBar from "./NavBar.svelte";
  import Footer from "./Footer.svelte";
  import config from "../stores/config";
  import { onMount } from "svelte";
  import axios from "axios";
  import * as ls from "local-storage";
  import get from "lodash.get";
  import Loading from "../shared/Loading.svelte";

  let loading = true;

  if (!ls.get("jwt")) window.location = "/#/login";

  onMount(async () => {
    if (!get($config, "currentUser.username")) {
      try {
        let response = await Promise.all([
          axios.get(`${$config.backendURL}/me`, {
            headers: { authorization: ls.get("jwt") },
          }),
        ]);

        config.update((prev) => ({
          ...prev,
          currentUser: response[0].data,
        }));

        loading = false;
      } catch (error) {
        loading = false;
        console.log(error);
      }
    } else {
      loading = false;
    }
  });
</script>

<div
  class={`bg-brand-white text-gray-600 font-medium tracking-wide w-full layout`}
  id="home"
>
  <!-- <div
  class={`bg-brand-white text-gray-600 font-medium tracking-wide w-full layout`}
  style="background-image: url(./images/pattern.svg);"
  id="home"
> -->
  {#if loading}
    <div class="h-screen w-full flex items-center justify-center">
      <Loading text="Veuillez Patienter..." />
    </div>
  {:else}
    <NavBar />
    <slot />
  {/if}
  <div class="mt-72" />
  <Footer />
</div>

<style>
  .layout {
    width: 100%;
    /* min-height: 100vh; */
  }
</style>
